import { render } from "./TemplateBlockForm.vue?vue&type=template&id=09478e5e&scoped=true"
import script from "./TemplateBlockForm.vue?vue&type=script&lang=js"
export * from "./TemplateBlockForm.vue?vue&type=script&lang=js"

import "./TemplateBlockForm.vue?vue&type=style&index=0&id=09478e5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09478e5e"]])

export default __exports__